import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';
import PracticalTexts from "../PracticalTexts";

export default class AssemblyInformation extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            buildingId: props.BuildingId,
            caller: props.Caller,
            data: null,
            loading: true,
            messageTemplateId: this.getDefaultGuid(),
            templates: [],
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: false,
            useIn: 'building'
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/buildingassemblyinformation/get", {
            id: this.getCurrentFormId(),
            buildingId: this.state.buildingId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });

        Promise.all([p1, p2]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = "0";

        this.httpPost("api/v1/buildingassemblyinformation/save", {
            id: this.state.id,
            dateHolding: this.convertMomentToDb(this.state.data.record.dateHolding),
            textMeeting: this.state.data.record.textMeeting,
            decisionsMade: this.state.data.record.decisionsMade,
            addressHolding: this.state.data.record.addressHolding,
            buildingId: this.state.data.record.buildingId,
            buildingBoardMembersRequest: this.state.data.record.buildingBoardMembersRequest,
            number: parseInt(this.state.data.record.number),
            showInBossProfile: this.state.data.record.showInBossProfile,
            showInUnitsProfile: this.state.data.record.showInUnitsProfile,
            messageTemplateId: this.state.messageTemplateId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankMember() {
        return {
            id: this.uuidv4(),
            post: '',
            customerId: this.getDefaultGuid(),
            customerName: ''
        }
    }
    addNewMember() {
        this.state.data.record.buildingBoardMembersRequest.push(this.getBlankMember());
        this.setState({ data: this.state.data });
    }
    setMemberValue(id, f, v) {
        this.state.data.record.buildingBoardMembersRequest.forEach(u => {
            if (u.id === id) {
                if (f === 'customerId') {
                    u[f] = v.value;
                    u['customerName'] = v.label;
                }
                else {
                    u[f] = v;
                }
            }
        });
    }
    removeMember(id) {
        var t = [];
        this.state.data.record.buildingBoardMembersRequest.forEach(u => {
            if (u.id !== id) {
                t.push(u);
            }
        });
        this.state.data.record.buildingBoardMembersRequest = t;
        this.setState({ data: this.state.data });
    }
    selectTextMeeting() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={5}
                    OnSelect="onSelectTextMeeting"
                />
            ),
        });

    }
    onSelectTextMeeting(e) {
        this.state.data.record.textMeeting = e.text;
        this.setState({ data: this.state.data });
    }
    selectDecisionsMade() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={7}
                    OnSelect="onSelectDecisionsMade"
                />
            ),
        });

    }
    onSelectDecisionsMade(e) {
        this.state.data.record.decisionsMade = e.text;
        this.setState({ data: this.state.data });
    }
    selectAddressHolding() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={8}
                    OnSelect="onSelectAddressHolding"
                />
            ),
        });

    }
    onSelectAddressHolding(e) {
        this.state.data.record.addressHolding = e.text;
        this.setState({ data: this.state.data });
    }    
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable">
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات مجمع" : "افزودن مجمع جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12" ky={this.state.data.record.textMeeting }>
                                        <div className="form-group">
                                            <label for="name" className="title1"><a onClick={e => this.selectTextMeeting()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>موضوع جلسه</label>
                                            <input defaultValue={this.state.data.record.textMeeting} onChange={e => this.state.data.record.textMeeting = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.dateHolding = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.dateHolding)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">شماره<span className="red">*</span></label>
                                            <input type="text" defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="20" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">برای مالکین<span className="red">*</span></label>
                                            <select defaultValue={this.state.data.record.showInBossProfile} onChange={e => this.state.data.record.showInBossProfile = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value="1">بله</option>
                                                <option value="2">خیر</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">برای مستاجرین<span className="red">*</span></label>
                                            <select defaultValue={this.state.data.record.showInUnitsProfile} onChange={e => this.state.data.record.showInUnitsProfile = parseInt(e.target.value)} className="form-control input-sm">
                                                <option value="1">بله</option>
                                                <option value="2">خیر</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">پیامک</label>
                                            <select defaultValue={this.state.messageTemplateId} onChange={e => this.state.messageTemplateId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group" key={this.state.data.record.addressHolding }>
                                            <label for="name" className="title1"><a onClick={e => this.selectAddressHolding()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>محل برگزاری</label><span className="red">*</span>
                                            <input type="text" defaultValue={this.state.data.record.addressHolding} onChange={e => this.state.data.record.addressHolding = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxLength="400"/>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group" key={this.state.data.record.decisionsMade }>
                                            <label for="name" className="title1"><a onClick={e => this.selectDecisionsMade()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>متن صورتجلسه</label>
                                            <textarea defaultValue={this.state.data.record.decisionsMade} onChange={e => this.state.data.record.decisionsMade = e.target.value} autocomplete="off" type="text" className="form-control input-sm" style={{ "height": "120px" }}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">

                                        <div className="col-sm-12">
                                            <h4 className="mt-4">لیست اعضا</h4>
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                        <td style={{ "width": "250px" }}>شخص</td>
                                                        <td>سمت</td>
                                                        <td></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.data.record.buildingBoardMembersRequest.map((item, index) =>
                                                        <tr key={item.id} className="accDataEntryGridRow invoice_grid_row" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                            <td>
                                                                <SelectAsync
                                                                    style={{ "width": "100%" }}
                                                                    defaultValue={item.customerId != this.defaultGuid() ? [{ value: item.customerId, label: item.customerName }] : null}
                                                                    isMulti={false}
                                                                    placeholder="انتخاب شخص"
                                                                    defaultOptions
                                                                    loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback,0,1)}
                                                                    onChange={e => this.setMemberValue(item.id, 'customerId', e)}
                                                                />
                                                            </td>
                                                            <td><input onChange={e => this.setMemberValue(item.id, 'post', e.target.value)} defaultValue={item.post} autocomplete="off" type="text" className="form-control input-sm ng-valid" /></td>
                                                            <td>
                                                                <span title="حذف سطر" onClick={e => this.removeMember(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                                <div onClick={e => this.addNewMember()} className="hand text-center p-2" style={{ "border": "dashed 0.13rem #6576ff", "margin-top": "10px", "display": "table-caption" }} >افزودن شخص جدید</div>
                                            </table>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}